import React, { memo } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import styles from './OptionsLoader.module.scss';

interface OptionsLoaderProps {
    count: number;
}

const HEIGHT = 52;

export const PaymentOptionLoader: React.FC<IContentLoaderProps> = ({ x = 0, y = 0, ...rest }) => (
    <ContentLoader
        className={styles.svg}
        speed={1}
        width="100%"
        height={HEIGHT}
        viewBox={`0 0 489 ${HEIGHT}`}
        backgroundColor="#f5f5f5"
        foregroundColor="#dbdbdb"
        preserveAspectRatio="none"
        {...rest}
    >
        <rect x="0" y="0" rx="4" ry="4" width="489" height={HEIGHT} />
    </ContentLoader>
);

const Skeleton: React.FC<OptionsLoaderProps> = ({ count = 3 }) => (
    <div className={styles.loader}>
        {new Array(count).fill(undefined).map((_, index) => (
            <PaymentOptionLoader key={`rect-${index}`} preserveAspectRatio="none" />
        ))}
    </div>
);

export const OptionsLoader = memo(Skeleton);
